export type { NavItemConfig } from './types';

// Grouped Menu Labels
export const L1_MENU_GROUPS = {
	MENU: 'L1MenuGroup',
	SHORTCUTS: 'L1ShortcutsGroup',
} as const;
